import services from './services.js';
import $http from '$http';
import { cloneDeep, util, isCorrectVal, isDate, lg } from 'utils';
export default {
    methods: {
        req_getOrderData(val) {
            let params = { Sid: this.sysSid, Session: this.sysSession, Id: val };
            $http.get("api/Order/GetERP_OrderById", params).then(res => {
                let { Data } = res.data;
                util.doResult(this, res, () => {
                    this.OrderData = Data;
                    this.equipmoney = this.OrderData.DiscountTemplet.CostHiPrePayMoney;
                    this.accountmoney = this.OrderData.DiscountTemplet.CostAccountBalance;
                    this.form.RefundPrice = this.OrderData.OrderActualPrice;
                    this.dialogVisible = true;
                });
            });
        },
        req_submit() {
            this.submitLoding = true;
            $http.post("api/Order/RefundOrderEx", this.form).then(res => {
                this.submitLoding = false;
                util.doResult(this, res, () => {
                    this.dialogVisible = false;
                    this.$notify({
                        title: "成功",
                        message: "退款审核成功",
                        type: "success"
                    });
                    this.$emit('reloadList');
                });
            });
        }
    }
}


// WEBPACK FOOTER //
// ./src/pages/Order/components/ensureRefund/services.js